import { ColorOptions } from '@jfs/ui-new'
import {
  AESEncryption,
  convertYear,
  getRandomAlphaNumString,
  hyphenSplashSeparatedDate,
  monthsMapper,
  padZero,
  RSAEncryption,
} from '@jfs/utils'
import AsyncStorage from '@react-native-async-storage/async-storage'
import CryptoJS from 'crypto-js'
import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'
import JSEncrypt from 'jsencrypt'
import { useEffect, useState } from 'react'
import { Dimensions, Platform } from 'react-native'
import { Config } from 'react-native-config'
import * as streamSaver from 'streamsaver'
import * as Yup from 'yup'
import {
  getInsightSummeryDateTimeRoundOff,
  roundOffCampaignFromDateAndToDate,
  roundOffFromDateAndToDate,
} from '../../src/util/apiRequestDateTimeRoundOff'
import { MerchantType } from '../data/models/Merchant'
import { mimeTypes } from '../data/static/data'
import { actionMenuStrings, staticStrings, transactionScreenStrings } from '../data/static/strings'
import { RootStore } from '../data/store'
import { getPathName, Routes } from '../nav/routes'

export const isOsMobile = () => {
  if (Platform.OS === 'android' || Platform.OS === 'ios') {
    return true
  } else {
    return false
  }
}

export const hasLowerCase = (str: string): boolean => {
  return /[a-z]/.test(str)
}

export function isEmpty(str: string): boolean {
  return !str || str.length === 0
}

export const compareNumberArray = (first: Array<number> = [], second: Array<number> = []): boolean =>
  first.length === second.length && first.every((e) => second.includes(e))

export const compareStringArray = (first: Array<string> = [], second: Array<string> = []): boolean =>
  first.length === second.length && first.every((e) => second.includes(e))

export const monthShotForm: Array<string> = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const roundOfToTwoDigits = (value: number): string => {
  if (value < 10) {
    return `0${value}`
  }
  return value?.toString() ?? ''
}

export const roundOfToTwoDigits2 = (value1: number): string => {
  const value = ++value1
  if (value < 10) {
    return `0${value}`
  }
  return value?.toString()
}
// If this is not reusable, move it to the required component
// It is reusable in 5 places
export const getBreadCrumbArray = (pathname: string): any[] => {
  if (pathname?.length > 1 && pathname.includes('/')) {
    let breadcrumb: any[] = []
    let paths = pathname.split('/')
    paths = paths[paths.length - 1] === '' ? paths.slice(0, paths.length - 1) : paths
    paths = paths[1] === '' ? paths.slice(1) : paths
    breadcrumb = paths.map((path: string) => {
      const newBread = { to: `${path}`, label: getPathName(path) }
      breadcrumb.push(newBread)
      return newBread
    })
    return JSON.parse(JSON.stringify(breadcrumb))
  }
  return []
}

export enum DateFormatTypes {
  YYYYMMDD = 'yyyymmdd',
  TIME_STAMP = 'timestamp',
  DAY_ONLY = 'dayonly',
  DATE_HYPHEN = 'datehyphen',
  DATE_STRING = 'datestring',
  DD_MMM_YYYY = 'DD MMM YYYY',
  DD_MM_YYYY = 'DD MM YYYY',
  DD_MM_YYYY_SLASH = 'DD/MM/YYYY',
  MONTH_STRING = 'monthstring',
  MONTH_STRING_ISO = 'monthstringiso',
  MONTH_STRING_ISO_WO_CORRECTION = 'monthstringisowocorrection',
  DATE_MILIS = 'dateinmili',
  DATE_AM_PM = 'dateampm',
  YYYYMMDD_HH_MM_SS = 'datetime',
  DATE_ONLY = 'dateonly',
  DATE_LOCAL = 'datelocal',
  DATE_ONLY_WITHOUT_TIME = 'datewithouttime',
  YYYYMMDD_ONLY = 'YYYYMMDD_ONLY',
  DD_MMM_YYYY_HH_MM_AMPM = 'DD_MMM_YYYY_HH_MM_AMPM',
  DD_MMM_TIME = 'DD MMM, hh:mm am_pm',
  DD_MMM_TIME_AMPM = 'DD MMM, hh:mm ampm',
  DD_MMM_WEEK = 'dd MMM, Week',
  DD_MMM_YYYY_AM_PM = 'DD_MMM_YYYY_AM_PM',
}

export const getMonthName: any = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
}

const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const formatAMPM = (date: Date): string => {
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12
  const minutesString = minutes < 10 ? `0${minutes}` : `${minutes}`
  var strTime = hours + ':' + minutesString + ' ' + ampm
  return strTime
}

// const newDateFormat = (date: Date): string => {
//   return `${date.getFullYear().toString().padStart(4, '0')}-${(date.getMonth() + 1)
//     .toString()
//     .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date
//     .getHours()
//     .toString()
//     .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
//     .getSeconds()
//     .toString()
//     .padStart(2, '0')}`
// }

export const dateFormatter = (date: Date | string, type: DateFormatTypes): string => {
  // console.log({ type })

  // //As per new date format expected in API's
  // if (date instanceof Date && type === DateFormatTypes.YYYYMMDD_HH_MM_SS) {
  //   return newDateFormat(date)
  // }

  if (typeof date === 'string' && type === DateFormatTypes.DATE_ONLY) {
    const dateObj: Date = date.includes(':') ? new Date(date) : new Date(+date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()}, ${formatAMPM(dateObj)}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DATE_ONLY_WITHOUT_TIME) {
    const dateObj: Date = date.includes(':') ? new Date(date) : new Date(+date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.MONTH_STRING) {
    const dateObj: Date = date.includes(':') ? new Date(date) : new Date(+date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${dateObj.getDate()} ${monthShotForm[dateObj.getMonth()]} ${dateObj.getFullYear()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.MONTH_STRING_ISO) {
    const dateObj: Date = fromIsoDate(date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${dateObj.getDate()} ${monthShotForm[dateObj.getMonth()]} ${dateObj.getFullYear()}`
  }
  if (typeof date === 'string' && type === DateFormatTypes.MONTH_STRING_ISO_WO_CORRECTION) {
    let dateObj: Date = new Date(date)
    try {
      if (isMobile(true)) {
        dateObj = dateTimeMobileOnly(date)
      }
    } catch (error) {
      console.log('date parsing error', error)
    }
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${dateObj.getDate()} ${monthShotForm[dateObj.getMonth()]} ${dateObj.getFullYear()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DATE_AM_PM) {
    let dateObj: Date = date.includes(':') ? new Date(date) : new Date(+date)
    try {
      if (isMobile(true)) {
        let parsedDate: any = date.split('.')[0]
        parsedDate = dateTimeMobileOnly(parsedDate)
        dateObj = parsedDate
      }
      // console.log('apptest dateTimeStringFormated input', date, dateObj)
    } catch (error) {
      console.log('date parsing error [DATE_AM_PM]', error)
    }
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()}, ${formatAMPM(dateObj)}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DD_MMM_YYYY_AM_PM) {
    let dateObj: Date = date.includes(':') ? new Date(date) : new Date(+date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${roundOfToTwoDigits(dateObj.getDate())} ${
      getMonthName[roundOfToTwoDigits2(dateObj.getMonth())]
    } ${dateObj.getFullYear()}, ${formatAMPM(dateObj)}`
  }
  if (typeof date === 'string' && type === DateFormatTypes.DATE_LOCAL) {
    const formatedDate = date.includes(':') ? new Date(date).toLocaleString() : new Date(+date).toLocaleString()
    return `${
      formatedDate.slice(6, 10) +
      '-' +
      formatedDate.slice(3, 5) +
      '-' +
      formatedDate.slice(0, 2) +
      formatedDate.slice(11)
    }`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DATE_MILIS) {
    const year = date.substring(0, 4)
    const month = date.substring(4, 6)
    const day = date.substring(6, 8)
    const hour = date.substring(8, 10)
    const minute = date.substring(10, 12)
    const second = date.substring(12, 14)
    const formatedDate = new Date(+year, +month - 1, +day, +hour, +minute, +second)
    return `${formatedDate.getTime()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.TIME_STAMP) {
    const dateObj: Date = date.includes(':') ? new Date(date) : new Date(+date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    const fDate = `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()} at ${dateObj.getHours()}:${dateObj.getMinutes()}:${dateObj.getSeconds()}`
    return fDate
  }

  if (typeof date === 'string' && date.length === 10 && type === DateFormatTypes.DD_MMM_YYYY) {
    const dateString = date?.substring(0, 2)
    const monthString = getMonthName[date?.substring(3, 5)]
    const year = date?.substring(6, 10)
    return `${dateString} ${monthString} ${year}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DD_MMM_TIME) {
    const dateStr = date?.split(',')?.[0]
    const dateString = dateStr?.substring(0, 2)
    const monthString = getMonthName[dateStr?.substring(3, 5)]

    const timeStr = date?.split(',')?.[1]
    const ampm = timeStr?.trim()?.split(' ')?.[1]?.toLocaleLowerCase()
    return `${dateString} ${monthString}, ${timeStr?.trim()?.split(' ')?.[0]}${ampm}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DD_MMM_TIME_AMPM) {
    const dateobj = new Date(date)
    const dateStr = date?.split('T')?.[0]
    const dateString = dateobj.getDate()
    const monthString = getMonthName[dateobj.getMonth()]
    const hourString = dateobj.getHours()
    const minute = dateobj.getMinutes()
    const hour = +hourString % 24
    const timeString =
      roundOfToTwoDigits(hour % 12 || 12) + ':' + roundOfToTwoDigits(minute) + (hour < 12 ? 'AM' : 'PM')
    return roundOfToTwoDigits(dateString), monthString, timeString
  }

  if (typeof date === 'string' && date.length === 10 && type === DateFormatTypes.DD_MMM_WEEK) {
    const dateString = date?.substring(0, 2)
    const monthString = getMonthName[date?.substring(3, 5)]
    const year = date?.substring(6, 10)
    const dateObj = new Date(Number(year), Number(date?.substring(3, 5)) - 1, Number(dateString))
    const week = weekdays[dateObj.getDay()]
    return `${dateString} ${monthString} ${week}`
  }
  if (date instanceof Date) {
    if (type === DateFormatTypes.YYYYMMDD) {
      return `${date.getFullYear()}-${roundOfToTwoDigits(date.getMonth() + 1)}-${roundOfToTwoDigits(date.getDate())} `
    }
    if (type === DateFormatTypes.DAY_ONLY) {
      return `${date.getDate()} ${monthShotForm[date.getMonth()]}`
    }
    if (type === DateFormatTypes.DATE_HYPHEN) {
      return `${date.getFullYear()}-${roundOfToTwoDigits(date.getMonth() + 1)}-${date.getDate()}`
    }
    if (type === DateFormatTypes.DATE_STRING) {
      return date.toLocaleDateString()
    }
    if (type === DateFormatTypes.YYYYMMDD_ONLY) {
      return `${date.getFullYear()}${roundOfToTwoDigits(date.getMonth() + 1)}${roundOfToTwoDigits(date.getDate())}`
    }
    if (type === DateFormatTypes.DD_MM_YYYY) {
      return `${roundOfToTwoDigits(date.getDate())}-${roundOfToTwoDigits(date.getMonth() + 1)}-${date.getFullYear()}`
    }
    if (type === DateFormatTypes.DD_MM_YYYY_SLASH) {
      return `${roundOfToTwoDigits(date.getDate())}/${roundOfToTwoDigits(date.getMonth() + 1)}/${date.getFullYear()}`
    }
  }

  if (typeof date === 'string' && type === DateFormatTypes.DD_MMM_YYYY_HH_MM_AMPM) {
    const year = date.substring(0, 4)
    const month = getMonthName[date.substring(4, 6)]
    const day = date.substring(6, 8)
    const hour = date.substring(8, 10)
    const minute = date.substring(10, 12)
    const ampm = +hour >= 12 ? 'PM' : 'AM'
    const timeWithoutMeridian = Number(hour) > 12 ? Number(hour) - 12 : hour
    return `${day} ${month} ${year}, ${returnFormattedTime(timeWithoutMeridian)}:${minute} ${ampm}`
  }
  return 'NA'
}

// TODO: mobile only date
export const dateTimeMobileOnly = (dateTime: string, withoutCorrection = false) => {
  if (typeof dateTime === 'string') {
    let parsedDate: any = new Date(Date.parse(dateTime))
    const userTimezoneOffset = withoutCorrection ? 0 : Math.abs(parsedDate.getTimezoneOffset() * 60000)
    parsedDate = new Date(parsedDate.getTime() - userTimezoneOffset)
    return parsedDate
  }
}

export const tableConfigData = new Map([
  [Routes.TRANSACTIONS, { status: 0, selectable: true, tabletype: Routes.TRANSACTIONS }],
  [Routes.SETTLEMENTS, { status: 1, selectable: undefined, tabletype: Routes.SETTLEMENTS }],
  [Routes.REFUNDS, { status: 2, selectable: undefined, tabletype: Routes.REFUNDS }],
  [Routes.PAYMENT_LINKS, { status: 3, selectable: undefined, tabletype: Routes.PAYMENT_LINKS }],
  [Routes.SUBSCRIPTIONS, { status: 4, selectable: undefined, tabletype: Routes.SUBSCRIPTIONS }],
  [Routes.DISPUTES, { status: 0, selectable: undefined, tabletype: Routes.DISPUTES }],
  [Routes.BULK_REPORT, { status: 0, selectable: undefined, tabletype: Routes.BULK_REPORT }],
  [Routes.BULK_SUMMARY, { status: 0, selectable: undefined, tabletype: Routes.BULK_SUMMARY }],
  [Routes.INITIATEREFUNDS, { status: 0, selectable: undefined, tabletype: Routes.INITIATEREFUNDS }],
  [Routes.BULK_REFUND, { status: 0, selectable: undefined, tabletype: Routes.BULK_REFUND }],
  [Routes.CAMPAIGNS, { status: 5, selectable: undefined, tabletype: Routes.CAMPAIGNS }],
  [Routes.DOWNLOADS, { status: 6, selectable: undefined, tabletype: Routes.DOWNLOADS }],
  [Routes.SETTLEMENTS_REPORTING, { status: 7, selectable: undefined, tabletype: Routes.SETTLEMENTS_REPORTING }],
])

export const tableConfig = (path: any) => {
  tableConfigData.get(path)
  const { status, selectable, tabletype } = tableConfigData.get(path) || {
    status: 0,
    selectable: undefined,
    tabletype: Routes.TRANSACTIONS,
  }
  return { status, selectable, tabletype }
}
export const getLoader = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.loading) {
      return apiHandlers[i]?.loading
    }
  }
  return false
}

export const getLoadingState = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.state === 'pending') {
      return true
    }
  }
  return false
}

export const getErrorState = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.state === 'rejected') {
      return true
    }
  }
  return false
}

export const isFetchComplete = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.state === 'pending') {
      return false
    }
  }
  return true
}

export const getError = (apiHandlers: any): string | null => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.error) {
      return apiHandlers[i]?.error?.message
    }
  }

  return null
}

export const getErrorMessage = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.data?.message) {
      return apiHandlers[i]?.data?.message
    }
  }
  return false
}
export const getNetworkResponseError = (data: any) => {
  console.log('getNetworkResponseError', data)

  let message = 'An unexpected error has occoured'
  let code = -1
  if (data?.error?.message) {
    message = data?.error?.message
    code = data?.error?.code
  } else if (data?.responseData?.message) {
    message = data?.responseData?.message
    code = data?.responseData?.code
  } else if (data?.responseMessage) {
    message = data?.responseMessage
    code = data?.responseCode
  } else if (data?.message) {
    message = data?.message
    code = data?.code
  }else if(data?.errorDetail?.message){
    message = data?.errorDetail?.message
    code = data?.errorDetail?.errorCode
  }

  return { message, code }
}


export const getErrorMessageFromResponse = (error: any): boolean => {
  const isArray = Array.isArray(error)
  const isObject = error?.constructor?.toString()?.indexOf('Object')
  let dataArray = null
  if (isObject) {
    dataArray = [{ data: error }]
  } else if (isArray) {
    dataArray = error
  }
  if (dataArray) {
    for (let i = 0; i < dataArray?.length; i++) {
      if (dataArray[i]?.data?.message) {
        // console.log('apiHandlers', dataArray[i]?.data?.message)
        return dataArray[i]?.data?.message
      } else if (dataArray[i]?.data?.data?.error?.message) {
        return dataArray[i]?.data?.data?.error?.message
      } else if (dataArray[i]?.data?.error?.message) {
        return dataArray[i]?.data?.error?.message
      } else if (dataArray[i]?.message) {
        return dataArray[i]?.message
      } else if (dataArray[i]?.error?.message) {
        return dataArray[i]?.error?.message
      }
    }
  } else {
    return false
  }
}

export const getBillPayErrorMessage = (error: any) => {
  let message = 'We are unable to process your request. Please try again later'
  let code = null
  if (error?.data?.errors) {
    error?.data?.errors?.forEach((err: any) => {
      message = err?.reason
      code = err?.code
    })
  } else if (error?.data?.error) {
    message = error?.data?.error_description ?? error?.data?.error?.message
    code = error?.data?.code ?? error?.data?.error?.code
  } else if (error?.data?.error?.message) {
    message = error?.data?.error?.message
    code = error?.data?.error?.code
  } else if (error?.errorMessage) {
    message = error.errorMessage
    code = error.errorCode
  } else if (error?.message) {
    message = error.message
    code = error.code
  } else if (error?.error) {
    message = error?.error?.error_description
    code = error?.error?.code
  } else if (error?.errors) {
    error?.errors?.forEach((err: any) => {
      if (err?.details) {
        message = err?.reason
        code = err?.code
      }
    })
  }

  return { message: message ?? 'We are unable to process your request. Please try again later', code: code }
}

export const getUserAck = (apiHandlers: any) => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.message) {
      return apiHandlers[i]?.message
    }
  }
  return null
}

export const isSessionLogout = (apiHandlers: any): boolean => {
  for (let i = 0; i < apiHandlers.length; i += 1) {
    if (apiHandlers[i]?.error?.code === 'A50013' || apiHandlers[i]?.error?.code === 'U50013') {
      return true
    }
  }
  return false
}

const searchView = new Map([
  [Routes.SUPPORT.slice(1), false],
  [Routes.FAQS.slice(1), false],
  [Routes.TERMS_OF_USE.slice(1), false],
  [Routes.MERCHANT_AGREEMENT.slice(1), false],
  [Routes.PRIVACY_POLICY.slice(1), false],
])

export const showSearchView = (path: string): boolean => {
  if (searchView.get(path) === undefined) {
    return true
  }
  return searchView.get(path) || false
}

export const getRangeDate = (fromDate: Date, toDate?: Date): string => {
  if (toDate) {
    return `${dateFormatter(fromDate, DateFormatTypes.DAY_ONLY)} ${fromDate.getFullYear()} ${'-'} ${dateFormatter(
      toDate,
      DateFormatTypes.DAY_ONLY,
    )} ${toDate.getFullYear()}`
  }
  return `${dateFormatter(fromDate, DateFormatTypes.DAY_ONLY)} ${fromDate.getFullYear()}`
}

export const compareBusiness = (item: MerchantType): number => {
  let comparison = 0
  if (
    item.merchantStatusString().toUpperCase() === staticStrings.active.toUpperCase() ||
    item.merchantStatusString().toUpperCase() === staticStrings.hotMerchant.toUpperCase()
  ) {
    comparison = -1
  }
  return comparison
}

export const getRandomNumber = (min: number, max: number): string => {
  return `${Math.floor(Math.random() * (max - min) + min)}`
}

export const getMobNumExcludingCCode = (mobile: string): string => {
  if (mobile !== undefined) {
    if (mobile.length === 13 && mobile.startsWith('+91')) {
      return mobile.slice(3, 13)
    }
    if (mobile.length === 10) {
      return mobile
    }
  }
  return ''
}

export const downloadPDF = {
  baseUrl: 'https://www.freepdfconvert.com/d/d398c9ed15e5a5cca637872f3ce8ebcc',
}

export const downloadXLS = {
  baseUrl: 'https://file-examples.com/wp-content/uploads/2017/02/file_example_XLS_10.xls',
}

const PUBLIC_ENC_KEY = isOsMobile() ? Config.REACT_APP_PUBLIC_ENC_KEY : window?._env_?.REACT_APP_PUBLIC_ENC_KEY
export const txnCounToDisableXlsx = Number(window?._env_?.REACT_APP_TXN_COUNT_TO_DISABLE_XLSX) ?? 100

export const AESEncrypt = (securityKey: string, data: string) => {
  let keyUtf8 = Utf8.parse(securityKey)
  let cipherPin = CryptoJS.AES.encrypt(data, keyUtf8, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return cipherPin.ciphertext.toString(Base64)
}

export const RSAEncrypt = (key: string, pub_key: any = PUBLIC_ENC_KEY) => {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(pub_key)
  return encrypt.encrypt(key)
}

export const generateRandomString = (length: number) => {
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}

export const getEncryptedPwdAndKey = (pwd: string): any => {
  const randomEncKey = generateRandomString(32)
  const aesEncString = AESEncrypt(randomEncKey, pwd)
  const encryptedKey = RSAEncrypt(randomEncKey)
  return { password: aesEncString, key: encryptedKey }
}

export const getEncryptedOtpPasswordAndKey = (otp: string, password: string): any => {
  const randomEncKey = generateRandomString(32)
  const aesEncOTP = AESEncrypt(randomEncKey, otp)
  const aesEncPass = AESEncrypt(randomEncKey, password)
  const encryptedKey = RSAEncrypt(randomEncKey)
  return { OTP: aesEncOTP, Password: aesEncPass, key: encryptedKey }
}

export const getEncryptedOtpAndKey = (otp: string): any => {
  const randomEncKey = generateRandomString(32)
  const aesEncOTP = AESEncrypt(randomEncKey, otp)
  const encryptedKey = RSAEncrypt(randomEncKey)
  return { OTP: aesEncOTP, key: encryptedKey }
}

export const compareArray = (first: Array<string | number> = [], second: Array<string | number> = []) => {
  return first.length === second.length && first.every((e) => second.includes(e))
}

export function safelyParseJSON(json: string) {
  let parsed: any = {}
  try {
    parsed = JSON.parse(json)
  } catch (e) {}
  return parsed
}

// export const getSessionData = (): any => {
//   // Do not stringify
//   const sesData = getStoredValue('sessionData')
//   return sesData !== null && sesData.toString().length > 0 ? JSON.parse(getStoredValue('sessionData')) : ''
// }

export const isSessionValid = (sessionData: any): boolean => {
  let sessionObj = sessionData
  if (typeof sessionData === 'string') {
    sessionObj = safelyParseJSON(sessionData)
  }
  if (sessionObj?.toString()?.length > 0) {
    if (!!sessionObj?.userAccessToken && sessionObj?.userAccessToken?.length > 0 && !!sessionObj?.userIdToken) {
      return true
    }
  }
  return false
}

export const getAmount = (amount: string) => {
  return +amount?.split(' ')[1] ?? 0
}

export const numberToLocalString = (num: number): string => {
  // const formatter = new Intl.NumberFormat('en-IN', {
  //   minimumFractionDigits: 2,
  // })
  const stringifiedNumber = num?.toString() ?? '0'
  const str = stringifiedNumber?.split('.')
  let IndianValue = '0'
  try {
    IndianValue = str[0]?.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,') + (str?.[1] ? '.' + str?.[1] : '')
  } catch (error) {}
  return IndianValue
}

export const getHHMMSS = (date: Date) => {
  return (
    ('0' + date?.getHours()).slice(-2) +
    ':' +
    ('0' + date?.getMinutes()).slice(-2) +
    ':' +
    ('0' + date?.getSeconds()).slice(-2)
  )
}

const getHHMMSSOnly = (date: Date) => {
  return ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2)
}

export const dateToLocaleISO = (mydate: Date) => {
  const year = mydate.getFullYear()
  const month = '0' + (mydate.getMonth() + 1)
  const day = '0' + mydate.getDate()
  const monthString = month.length > 2 ? month.slice(1) : month.slice(0)
  const dayString = day.length > 2 ? day.slice(1) : day.slice(0)
  const time = `${padZero(mydate.getHours())}:${padZero(mydate.getMinutes())}:${padZero(mydate.getSeconds())}`
  return year + '-' + monthString + '-' + dayString + 'T' + time + '.000' + 'Z'
}

export const isMobile = (useIsLargeScreen: boolean) => {
  const isLarge = useIsLargeScreen

  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    return true
  } else {
    if (!isLarge) {
      return true
    } else {
      return false
    }
  }
}

export const recentsTabData = [{ title: 'Transactions' }, { title: 'Settlements' }, { title: 'Refunds' }]
export const getTitle: any = {
  details: 'Transaction Details',
  paymentDetails: 'Payment Details',
  settlementDetails: 'Settlement Details',
  customerDetails: 'Customer Details',
  refund: 'Refund Details',
}

export const capitalizeTxnDetailsKeys: any = {
  timestamp: 'Date',
  ern: 'ERN',
  failureReason: 'Failure Reason',
  channel: 'Channel',
  amount: 'Amount',
  originalTxnAmt: 'Original Txn Amt',
  ugst: 'ugst',
  igst: 'ugst',
  cgst: 'cgst',
  sgst: 'sgst',
  rrn: 'RRN',
  status: 'Status',
  currency: 'Currency',
  paymentMode: 'Payment Mode',
  cardNumber: 'Card Number',
  bankRefNum: 'Bank Ref No.',
  paymentType: 'Paid Via',
  customerName: 'Customer Name',
  settlementDate: 'Date',
  utrNumber: 'UTR Number',
  settlementFilename: 'File Name',
  id: 'Id',
  name: 'Name',
  mobileNumber: 'Mobile Number',
  email: 'Email',
  addressLine1: 'Address Line 1',
  addressLine2: 'Address Line 2',
  city: 'City',
  state: 'State',
  zipCode: 'Zip Code',
  pending: 'Pending',
  requestedDate: 'Requested Date',
  processdDate: 'Processed Date',
  refundMessage: 'Refund Message',
  processed: 'Processed',
  transactionAmount: 'Transaction Amount',
  refundAmount: 'Refund Amount',
  refundInitiatedDate: 'Refund Initiated Date',
  refundStatus: 'Refund Status',
  refundDate: 'Refunded Date',
  originalTransactionId: 'Transaction Id',
  biller: 'Biller',
  customerId: 'Customer ID',
  transactionId: 'Transaction ID',
  bbpsTxnId: 'BBPS Transaction ID',
  paidBy: 'Paid by',
  txnDateTime: 'Transaction Date & Time',
  consumerDetails: 'Consumer Details',
  acquirerTerminal: 'Terminal Id',
  accountNumber: 'Customer VPA',
  issRefData: 'Reference No.',
  invoice: 'Merchant Ref No.',
  failureMessage: 'Failure reason',
}

export const getFromStore = async (key: string) => {
  const value = await AsyncStorage.getItem(key)
  return value
}

export const getVoiceBoxInfoFromStore = async () => {
  const value = await AsyncStorage.getItem('voiceBoxInfo')
  return value ?? ''
}

const modifyValueWithResponseTime = (value: any) => {
  const valObject = JSON.parse(value)
  valObject.responseTime = new Date().getTime()
  return JSON.stringify(valObject)
}

export const storeData = async (key: string, value: any) => {
  try {
    if (key === 'sessionData') {
      if (value.trim() !== '') {
        value = modifyValueWithResponseTime(value)
      }
    }
    await AsyncStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.log('error storing data', key)
  }
}

export const removeDataFromStorage = async (key: string) => {
  try {
    await AsyncStorage.removeItem(key)
  } catch (e) {
    console.log('error storing data', key)
  }
}

export const formatTimer = (timeLeft: number) => {
  const mins = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60
  let formattedSeconds = ''
  if (seconds < 10) {
    formattedSeconds = `0${seconds}`
  } else {
    formattedSeconds = String(seconds)
  }
  return `0${mins}:${formattedSeconds}`
}

export const showLast4Chars = (string: string) => {
  let str = string?.replace(/.(?=.{4})/g, 'X')
  let replaceString = str?.match(/.{1,4}/g)
  let newStringWithSpace = replaceString?.join(' ')
  return newStringWithSpace
}

export const extractFirstLetterFromName = (word: string) => {
  const acronym = word?.split(/\s/)?.reduce((response, newWord) => (response += newWord?.slice(0, 1)), '')
  return acronym.substring(0, 2).toUpperCase()
}

const screens: any = ['', 'Transactions', 'Accept Payment', 'Settlements', 'Profile']
export const getScreenTitle: any = () => {
  return screens
}

export const hasPermissions = async () => {
  return Promise.resolve(true)
}

export const hasNotificationPermission = async () => {
  return Promise.resolve(false)
}

export const hasReadContactsPermission = async () => {
  return Promise.resolve(false)
}

export const autoCapitalisation = (s: string) => {
  return (s = s.replace(/([A-Z])/g, ' $1').trim())
}

export const getDeviceInfo = (mobile?: string | undefined | number) => {
  let data = {
    location: 'Reliance Corporate ParkNavi Mumbai MHIN',
    ip: '103.134.128.109',
    type: 'desktop',
    id: '352982106407128',
    os: Platform.OS,
    capability: '520000020001000400701392929292920000000000',
    mobile: mobile, //mobile ??
    app: 'PG1.0.0',
    appName: 'PG',
    simId: '405874069531101', //send correct if possible
    appVersion: '1.0.0',
    sdkVersion: '1.1.1',
    deviceToken: '865124034278459',
    geocode: {
      latitude: '19.1269519',
      longitude: '73.0107141',
    },
    initiatorMobile: '918169619527',
  }
  return JSON.stringify(data)
}

export const Colors = {
  PRIMARY: '#DF9F39' as ColorOptions, // for primary text color
  SECONDARY: '#966D2E' as ColorOptions, // for BG
  PRIMARY_STORNG: '#F2BE75' as ColorOptions, // for navigation link
  PRIMARY_LIGHT: '#F0F8FB',
  WHITE: '#ffffff',
  JIO_PRIMARY: '#214796' as ColorOptions,
  JIO_PRIMARY_ALPHA: 'rgb(74,104,169)' as ColorOptions,
  JIO_SECONDARY_ALPHA: 'rgb(119,142,190)' as ColorOptions,
  BLUE_LIGHT_ALPHA: 'rgb(58,83,152)' as ColorOptions,
  SECONDARY_GREY: '#E1E5E8' as ColorOptions,
  PRIMARY_GREY: 'rgba(0, 0, 0, 0.65)' as ColorOptions,
  GREY_SEPARATOR: '#F0F0F0' as ColorOptions,
  BLUE_A9: '#4DBCA9',
  YELLOW_27: '#E89B27',
  BLUEFF: '#2797E8',
  VIOLETB7: '#663AB7',
  GREEN32: '#78B532',
  BLUE_FF: '#709DFF',
  BLUE_SHADE_PRIMARY: '#0070B6',
  BLACK_1A: '#7575751A',
  SEPARATOR: '#CCCCCC66',
  LIGHT_BLACK: '#7F7F7F',
  DISABLED_GREY: '#E0E0E0',
  GREEN_C: '#12802B',
  BLUE_C: '#1386B0',
  ORANGE_C: '#CC7F00',
  RED_C: '#CA4848',
  GREEN_BG_C: '#11C13A1A',
  BLUE_BG_C: '#1386B01A',
  ORANGE_BG_C: '#CC7F001A',
  RED_BG_C: '#CA48481A',
  GREY_BORDER: '#CCCCCC99',
  BRAND_PRIMARY_ACTION: '#1386B0',
  GREY_SHADE: '#CCCCCC',
  GREY_C: '#707070',
  LIGHT_GREY: '#0000001F',
  GRAY_SHADOW: '#00000029',
  DARK_GREY: '#555555',
  SPLASH: '#24397A',
  OTP_GREY: '#7F7F7F' as ColorOptions,
  HALF_WHITE: '#FAFAFA',
  DARK_BLUE: '#034EA8',
  TEAL: '#0186B01A',
  GREY_SHADE_1: '#BBBBBB',
  HELPER_TEXT: '#A0A0A0' as ColorOptions,
  MUD_YELLOW_DARK: '#99661F' as ColorOptions,
  WASHED_YELLOW: '#99661F50' as ColorOptions,
  WASHED_YELLOW_LIGHT: '#FEECA484' as ColorOptions,
  CITY_PINK: '#FF550021' as ColorOptions,
  ORANGE_4A: '#BE714A',
  AQUA_BLUE: '#F4F9FF',
  OCEAN_BLUE: '#4D89D3' as ColorOptions,
  BLACK_35: '#353535',
  GREY_90: '#909090',
  GREY_77: '#777777',
  BLACK_71: '#717171',
  BLACK_1D: '#1D1D1D',
  BLACK: '#000000' as ColorOptions,
  BLACK_LIGHT: '#00000050',
  ERROR: '#FC5A5A',
  BLUE_0A: '#0186B00A',
  BLACK_21: '#212121',
  BLACK_14: '#141414' as ColorOptions,
  BLACK_21_0D: '#2121210D', // 5% OF #212121
  GREY_E5: '#E5E5E5',
  LIGHT_GRAY: '#D0D0D0',
  GREY_EB: '#EBEBEB',
  BLUE_80: '#0186B080',
  TRANSPARENT: '#00000000',
  MODAL_SHADOW: 'rgba(0,0,0,0.6)',
  TEST_MODE: '#e68c32',
  LIVE_MODE: '#11c13a',
  CalendarColor: 'rgba(1,134,176,0.25)',
  BORDER_COLOR: '#00000014',
  LIGHT_BLUE: '#edf5fa',
  OVERLAY: 'rgba(255,255,255,0)',
  PRIMARY_GRADIENT: '#1F71A2',
  BASIC_WHITE: '#F0F5FA',
  SECONDARY_WHITE: '#FAFEFF',
  ERROR_RED: '#C94949',
  INFO_BORDER: '#E68E0052',
  INFO_BG: '#E68E0014',
  REPORT_PRIMARY: '#225BD0',
  SLATE: '#5D5D5D',
  DISABLED_PRIMARY: 'rgba(34, 91, 208, 0.08)',
  BORDER_LIGHT_BLUE: '#B9CBF0',
  BG_LIGHT_BLUE: '#F7FAFF',
  FONT_GREY: '#202F4DDE',
  LABEL_GREY: '#202F4D8A',
  FONT_BLACK: '#202F4D',
  BG_BLUE_LIGHT: '#2269FC1F',
  BG_BLUE: '#2269FC',
  FONT_COLOR: '#7A8294',
  PRIMARY_BLUE: '#0F3CC9',
  BLACK_14: '#141414',
  GREY_BG: '#B5B5B5',
  GREEN_SUCCESS_BG: '#00B259',
  GREEN_ERROR_BG: '#E30513',
  CHATBOT_ICON: '#FFBE56',
}

export const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F' as ColorOptions,
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014' as ColorOptions,
  zIndex: 10,
}

export const viewShadowStyle = {
  shadowOffset: { width: 0, height: 2 },
  shadowRadius: 3,
  shadowColor: '#0000001F' as ColorOptions,
  borderRadius: 4,
  zIndex: 4,
}

export enum FontWeight {
  THIN = '100',
  ULTRA_LIGHT = '200',
  LIGHT = '300',
  REGULAR = '400',
  MEDIUM = '500',
  SEMI_BOLD = '600',
  BOLD = '700',
  HEAVY = '800',
  BLACK = '900',
  TEXT_BOLD = 'bold',
  TEXT_NORMAL = 'normal',
}

export enum FontFamily {
  MEDIUM = 'jiotype-medium',
  BOLD = 'jiotype-bold',
  LIGHT = 'jiotype-light',
  LIGHT_ITALIC = 'jiotype-light-italic',
  MEDIUM_ITALIC = 'jiotype-medium-italic',
  BLACK = 'jiotype-black',
}

export const customTheme = {
  colors: Colors,
}

export const fromDateTime = (fromDate: Date): string => {
  const startTime = getHHMMSS(fromDate)
  return `${dateFormatter(fromDate, DateFormatTypes.YYYYMMDD)}${startTime}`
}

export const toDateTime = (toDate: Date, isInfiniteScroll?: boolean, forceEndOfDay: boolean = false): string => {
  const today = new Date(Date.now())
  /* check if end date in past , so end time will be 23:59:59 ,
  if its today so time will be current time */
  const endTime =
    !forceEndOfDay && (toDate.toDateString() === today.toDateString() || isInfiniteScroll)
      ? getHHMMSS(toDate)
      : transactionScreenStrings.endTime
  return `${dateFormatter(toDate, DateFormatTypes.YYYYMMDD)}${endTime}`
}

export const customToDateTime = (toDate: Date, isCustomRange?: boolean): string => {
  const today = new Date(Date.now())
  /* check if end date in past , so end time will be 23:59:59 ,
  if its today so time will be current time */
  const endTime = isCustomRange ? transactionScreenStrings.endTime : getHHMMSS(today)
  return `${dateFormatter(toDate, DateFormatTypes.YYYYMMDD)}${endTime}`
}

export const tillLastDateTime = (): string => {
  const yest = new Date(Date.now())
  yest.setDate(yest.getDate() - 1)
  return `${dateFormatter(yest, DateFormatTypes.YYYYMMDD)}${transactionScreenStrings.endTime}`
}

export const getDateInyyyymmdd = (datetoconvert: Date): string => {
  return dateFormatter(datetoconvert, DateFormatTypes.YYYYMMDD_ONLY)
}

export const toIsoDate = (date: Date): string => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()
}

export const fromIsoDate = (isoDateString: string): Date => {
  const isoDate = new Date(isoDateString)
  return new Date(isoDate.getTime() + isoDate.getTimezoneOffset() * 60000)
}

export const toMidnight = (date: Date): Date => {
  const midnightDate = new Date(date)
  midnightDate.setHours(0, 0, 0, 0)
  return midnightDate
}

export const toLateNight = (date: Date): Date => {
  const midnightDate = new Date(date)
  midnightDate.setHours(23, 59, 59, 999)
  return midnightDate
}

export const setToDateTime = (secondDay: Date) => {
  const date: Date = new Date(Date.now())
  const todayDay = date.getDate()
  const todayMonth = date.getMonth()
  const todayYear = date.getFullYear()
  const isTodaySelected = () => {
    if (
      todayDay === secondDay.getDate() &&
      todayMonth === secondDay.getMonth() &&
      todayYear === secondDay.getFullYear()
    ) {
      return true
    } else {
      return false
    }
  }

  if (isTodaySelected()) {
    return date
  } else {
    return toLateNight(secondDay)
  }
}
export const getBase64Image = (url: string) => {
  return `data:image/png;base64,${url}`
}

export function testProps(id: string) {
  return { testID: id, accessibilityLabel: id }
}

export const getVersionNumber = () => Config.VERSION_NAME ?? '3.0'

export const getLoaderMessage = (state: string, mobile: string) => {
  if (state === 'pending') {
    return staticStrings.fetchingLinkedBank + ' ' + mobile
  }
  return staticStrings.fetchBanks
}

export const passwordPatternVerifier = (
  text: string,
  confPassword: string,
  setDataValid: any,
  setShowPwdCheckView: any,
  password: string,
  handleChecked: any,
  setSelectedList: any,
  checkedData: any,
  forgotPwdStrings: any,
) => {
  if (confPassword.length > 0 && text.length > 0) {
    setDataValid(confPassword === text)
  }
  setShowPwdCheckView(password !== text)
  if (text.length >= 8) {
    handleChecked('1')
  } else if (checkedData.includes('1')) {
    setSelectedList(checkedData.filter((item: string) => item !== '1'))
  }
  if (text.toUpperCase() !== text) {
    handleChecked('2')
  } else if (checkedData.includes('2')) {
    setSelectedList(checkedData.filter((item: string) => item !== '2'))
  }
  if (forgotPwdStrings.capitalLettersRegex.test(text)) {
    handleChecked('3')
  } else if (checkedData.includes('3')) {
    setSelectedList(checkedData.filter((item: string) => item !== '3'))
  }
  if (forgotPwdStrings.oneSpecialCharRegex.test(text)) {
    handleChecked('4')
  } else if (checkedData.includes('4')) {
    setSelectedList(checkedData.filter((item: string) => item !== '4'))
  }
  if (forgotPwdStrings.oneDigitRegex.test(text)) {
    handleChecked('5')
  } else if (checkedData.includes('5')) {
    setSelectedList(checkedData.filter((item: string) => item !== '5'))
  }
}

export const SnakeCase = (str: string) => {
  const newString = str?.toLowerCase().replace('_', ' ')
  function capitalize(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  const caps = newString.split(' ').map(capitalize).join(' ')
  return caps
}

let isSmallDevices = false

export const isSmallDevice = () => {
  return isSmallDevices
}

export const setIsSmallDevice = (value: boolean) => {
  isSmallDevices = value
}

export const returnFormattedTime = (val: number | string) => {
  const stringifiedNumber = val?.toString()
  if (Number(val) < 10 && stringifiedNumber?.length < 2) {
    return `0${val}`
  } else {
    return val
  }
}

export const fromClDateTime = (fromDate: Date): string => {
  return `${dateFormatter(fromDate, DateFormatTypes.YYYYMMDD_ONLY)}${transactionScreenStrings.starTimeOnly}`
}

export const toCLDateTime = (toDate: Date, isCustomDate: boolean): string => {
  const today = new Date(Date.now())
  const endTime = !isCustomDate ? getHHMMSSOnly(today) : transactionScreenStrings.endTimeOnly
  return `${dateFormatter(toDate, DateFormatTypes.YYYYMMDD_ONLY)}${endTime}`
}

export const getAppId = (): string => {
  return Platform.OS === 'android' ? Config.APPLICATION_ID : 'com.jiopay.business.sit'
}

export const convertDateToYYYYMMDD = (date: any) => {
  const dateCopy = date?.split('/')
  return `${dateCopy[2]}${dateCopy[1]}${dateCopy[0]}`
}

export const convertFrom12To24Format = (time: any) => {
  const splittedTime = time?.split(':')
  const extractHour = `${splittedTime[0]}`
  const extractMin = `${splittedTime[1]}`
  const extractMeridian = `${splittedTime[2]}`
  function recursivefrom12to24() {
    let formattedTime
    let formattedHour = parseInt(extractHour, 10)
    const formattedMinutes = parseInt(extractMin, 10)
    if (extractMeridian.toUpperCase() === 'PM') {
      formattedHour = formattedHour !== 12 ? formattedHour + 12 : formattedHour
    } else {
      formattedHour = formattedHour === 12 ? 0 : formattedHour
    }
    formattedTime = new Date(new Date().setHours(formattedHour, formattedMinutes, 0, 0))?.toLocaleTimeString('en-GB')
    const timeSplitter = formattedTime?.split(':')
    const timeValue = timeSplitter?.[0] + timeSplitter?.[1] + timeSplitter?.[2]
    return timeValue
  }
  return recursivefrom12to24()
}

export const convertDateToYearAndTime = (str: any) => {
  var year = str?.substring(0, 4)
  var month = str?.substring(4, 6)
  var day = str?.substring(6, 8)
  var hour = str?.substring(8, 10)
  var minute = str?.substring(10, 12)
  var date = `${day}/${month}/${year} at ${hour}:${minute}`
  return str ? date : ''
}

export const getErrorMsg = (code: string, msg?: string): string => {
  const getMsg: any = {
    22424: 'The mobile number is already registered with us. Please Login',
    22410: 'Please enter correct password or else click on Forgot password',
    33410: 'Invalid OTP entered',
    22401: 'Mobile number not registered',
    22408:
      msg ??
      'Your account is temporarily locked due to security reasons. Please try to login after 10 minutes, or reach out to your Admin for unlocking your account.',
  }
  return getMsg[code] ?? msg
}

export const bulkRefundErrorMessage = (code: string, msg: string): string => {
  const getMsg: any = {
    '300': 'No file exist in the specified folder location.',
    '312': 'Something went wrong.',
    '313': 'Count in the file name is not same as actual content count.',
    '320': 'File with same name already exists.',
    '321': 'Failed to parse filename to get count value.',
  }

  return getMsg[code] ?? msg
}

export const getEncryptedAuthCodeAndCodeVerifier = (authCode: string, codeVerifier: string): any => {
  const randomEncKey = generateRandomString(32)
  const aesAuthEncString = AESEncrypt(randomEncKey, authCode)
  const codeVerifierEncString = AESEncrypt(randomEncKey, codeVerifier)
  const encryptedKey = RSAEncrypt(randomEncKey)
  return { codeVerifierEnc: codeVerifierEncString, authCodeEnc: aesAuthEncString, key: encryptedKey }
}

export const getEncryptedAuthCodeAndCodeVerifierWithPublickey = (
  authCode: string,
  codeVerifier: string,
  publicKey: string,
) => {
  const randomEncKey = getRandomAlphaNumString(32)
  const aesAuthEncString = AESEncryption(randomEncKey, authCode)
  const codeVerifierEncString = AESEncryption(randomEncKey, codeVerifier)
  const encryptedKey = RSAEncryption(randomEncKey, publicKey)
  return { codeVerifierEnc: codeVerifierEncString, authCodeEnc: aesAuthEncString, key: encryptedKey }
}

export const pkceBase64URLEncode = (str: any) => {
  const pkceBase64 = str.toString(CryptoJS.enc.Base64).replace(/[=]/g, '').replace(/\+/g, '-').replace(/\//g, '_')
  return pkceBase64
}

export const pkceGenerateRandomString = (length: number) => {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

export const pkceGetCodeVerifier = (size: number) => {
  const codeVerifier = pkceGenerateRandomString(size)
  return codeVerifier
}

export const pkceCodeChallenge = (verifier: string) => {
  const codeChallenge = pkceBase64URLEncode(CryptoJS.SHA256(verifier))
  return codeChallenge
}

export const countDecimals = function (value: number | string) {
  if (value % 1 !== 0) {
    return value?.toString()?.split('.')[1]?.length
  }
  return 0
}

export const toLocaleString = (dateStr: string | Date) => {
  const passedDate = new Date(dateStr),
    mnth = ('0' + (passedDate.getMonth() + 1)).slice(-2),
    day = ('0' + passedDate.getDate()).slice(-2)
  return [day, mnth, passedDate.getFullYear()].join('/')
}

export const onlyDigit = /^[0-9]*$/

const getUncheckedData = (checkboxData: any) => {
  return checkboxData
    .filter((item: any) => {
      return !item.isChecked
    })
    .map((item: any) => {
      return item.text.toUpperCase()
    })
}

export const getHAxisData = (xAxis: any) => {
  let hAxisData: any[] = []
  for (let i = 0; i < xAxis.length; i++) {
    hAxisData.push({ text: xAxis[i], isChecked: true })
  }
  return hAxisData
}

export const filtereDataForBarUnChecks = (filteredchartData: any, pref: any, checkboxData: any) => {
  if (pref.segmentedVs.length !== 0) {
    const uncheckedData = getUncheckedData(checkboxData)
    if (uncheckedData.length > 0) {
      for (let i = 0; i < filteredchartData.length; i++) {
        if (
          typeof filteredchartData[i][0] === 'string' &&
          uncheckedData.includes(filteredchartData[i][0].toUpperCase())
        ) {
          filteredchartData.splice(i, 1)
          if (i > 0) {
            i--
          }
        }
      }
    }
  }

  return filteredchartData.length === 1 ? [] : filteredchartData
}

export const filterSegentedByUnchecks = (dataForBarUnChecks: any, segmentedByData: any) => {
  const uncheckedData = segmentedByData
    .filter((item: any) => {
      return !item.checked
    })
    .map((item: any) => {
      return item.segment
    })

  if (uncheckedData.length > 0) {
    const indexToRemove: any = []

    uncheckedData.forEach((uncheckedElement: any) => {
      const indexOfUncheckedElement = dataForBarUnChecks[0]?.indexOf(uncheckedElement)
      if (indexOfUncheckedElement && indexOfUncheckedElement !== -1) {
        indexToRemove.push(indexOfUncheckedElement)
        indexToRemove.push(indexOfUncheckedElement + 1)
      }
    })
    dataForBarUnChecks.forEach((element: any) => {
      indexToRemove.forEach((indextoRemove: any, index: any) => {
        element.splice(indextoRemove - index, 1)
      })
    })
  }
  if (!dataForBarUnChecks[0] || dataForBarUnChecks[0].length === 1) {
    return []
  }

  return dataForBarUnChecks
}

export const getChartData = (filteredchartData: any, pref: any, checkboxData: any, segmentedByData: any) => {
  let dataForBarUnChecks = filtereDataForBarUnChecks(filteredchartData, pref, checkboxData)
  dataForBarUnChecks = filterSegentedByUnchecks(dataForBarUnChecks, segmentedByData)
  const getLabels = (data: any) => {
    const labels: any = []
    data?.map((item: any, index: number) => {
      index % 2 !== 0 && labels.push(item)
    })
    return labels
  }
  const labels = getLabels(dataForBarUnChecks?.[0])

  const data: any = []
  const keys: any = []
  dataForBarUnChecks.map((item: any, i: number) => {
    if (i > 0) {
      const values = item.filter((_, index: number) => index % 2 !== 0)
      const key = item.filter((_, index: number) => index === 0)
      data.push(values)
      keys.push(key)
    }
  })

  let allZeros = true
  const output: any = []
  for (let index = 0; index < labels.length; index++) {
    const retData: any = []
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.[index] !== 0) {
        allZeros = false
      }
      retData.push(data?.[i]?.[index])
    }
    output.push(retData)
  }
  const dataset: any = []
  !allZeros &&
    output.map((item: any, index: number) => {
      const color =
        segmentedByData?.filter((obj: any) => obj?.segment === labels[index])?.[0]?.color?.color ?? '#c94949'
      const retItem = {
        borderColor: color,
        borderWidth: 1.5,
        data: item,
        fill: false,
        pointRadius: 0,
        pointBackgroundColor: color,
        label: labels[index],
        barThickness: 24,
        backgroundColor: color,
      }
      dataset.push(retItem)
    })
  const finalData = {
    datasets: dataset,
    labels: keys,
  }
  return finalData
}

export const getType: any = {
  1: 'Inline',
  2: 'Standalone',
}

export const getFrequency: any = {
  1: 'Once',
  2: 'Daily',
  3: 'Weekly',
  4: 'Monthly',
  5: 'Quarterly',
  6: 'Half Yearly',
  7: 'Yearly',
  8: 'As presented',
}

export const localStringToNumber = (num: string): number => {
  const noCurrency = num?.slice(1) ?? ''
  return +noCurrency?.replace(/,/g, '') ?? 0
}

export const dateInUTC = (date: string): string => {
  return `${date[3] + date[4]}-${date[0] + date[1]}-${date.slice(6)}`
}

export enum FormOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export interface DateType {
  fromDate: Date
  toDate?: Date
  position?: { left?: number; top?: number; visible: boolean }
}

export interface FormikValues {
  [field: string]: string // An object with keys as fieldName's and values as string/ number
}

export enum ActionType {
  DownloadBulkFile,
  ProcessBulkRefund,
  DeleteBulkRefund,
  DownloadSettlementCSV,
  RemoveSettlement,
  InitiateRefund,
  Delete,
}

export enum ProgressTypes {
  OTP = 'otp',
  FORGOT_PWD = 'forgotPassword',
  RESET_PWD = 'resetPassword',
  SIGN_UP_STEP = 'signupStep0',
  SIGN_UP_STEP_1 = 'signupStep1',
  SIGN_UP_STEP_2 = 'signupStep2',
}

const getDecimalPart = (amount: number) => {
  return (amount - Math.floor(amount)).toFixed(2).substring(1)
}

const getNonDecimalPart = (amount: number) => {
  let nonDecimalPart = Math.floor(amount)
  if (nonDecimalPart < 1000) {
    return nonDecimalPart
  } else {
    return (
      Math.floor(nonDecimalPart / 1000)
        .toString()
        .replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
      ',' +
      (nonDecimalPart % 1000).toString().padStart(3, '0')
    )
  }
}

export const getFormatedMoney = (val: number, isCount: boolean) => {
  let formatedVal: any
  if (val >= 10000000) {
    formatedVal = (isCount ? '' : '₹ ') + (getNonDecimalPart(val / 10000000) + getDecimalPart(val / 10000000)) + ' Cr'
  } else if (val >= 100000) {
    formatedVal = (isCount ? '' : '₹ ') + (val / 100000).toFixed(2) + ' L'
  } else {
    formatedVal = (isCount ? '' : '₹ ') + getNonDecimalPart(val) + getDecimalPart(val)
  }
  if (isCount) {
    formatedVal = removeDecimal(formatedVal)
  }
  return formatedVal
}
export const shouldShowTooltip = (val: number) => {
  return val >= 100000
}

export const getCommaFormatedVal = (val: number, isCount: boolean = false) => {
  let formatedVal: any = (isCount ? '' : '₹ ') + getNonDecimalPart(val) + getDecimalPart(val)
  if (isCount) {
    formatedVal = removeDecimal(formatedVal)
  }
  return formatedVal
}

export const removeDecimal = (val: string) => {
  const spliteedVar = val.split('.')
  if (spliteedVar.length > 1) {
    return spliteedVar[0] + spliteedVar[1].replace(spliteedVar[1].substring(0, 2), '')
  }
  return spliteedVar[0]
}

export const calendarWebWidth = 690
export const calendarWebHeight = 386

export const isStringBlank = (str: string) => {
  if (str && typeof str === 'string' && str?.trim()?.length > 0) {
    return false
  } else {
    return true
  }
}

export const getDate = (date: any) => {
  if (isEmpty(date)) {
    return 'NA'
  }
  const timestamp = getTimeStamp(date)
  const dateWithTimestamp = new Date().setTime(timestamp)
  return dateFormatter(new Date(dateWithTimestamp), DateFormatTypes.DD_MM_YYYY)
}

export const getTimeStamp = (date: any, time = '00:00:00') => {
  const onlyDate = date?.split(' ')
  const onlyTime = time?.split(':')
  const months: any = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  }
  const formattedDate = new Date(
    Number(onlyDate?.[5]),
    months[onlyDate?.[1]],
    Number(onlyDate?.[2]),
    Number(onlyTime?.[0]),
    Number(onlyTime?.[1]),
    Number(onlyTime?.[2]),
  )?.getTime()

  return formattedDate
}

export const getTime = (date: any, time = '00:00:00') => {
  const onlyDate = date?.split('-')
  const onlyTime = time?.split(':')
  const formattedDate =
    new Date(
      Number(onlyDate?.[0]),
      Number(onlyDate?.[1] - 1),
      Number(onlyDate?.[2]),
      Number(onlyTime?.[0]),
      Number(onlyTime?.[1]),
      Number(onlyTime?.[2]),
    )?.getTime() ?? 0

  return formattedDate ?? 0
}
export const getRefundSource = (src: any): string => {
  const source: any = {
    '1': 'PG',
    '2': 'SWITCH',
  }
  return source[src] ?? 'PG'
}

export const getSearchFilterKey: any = {
  'Merchant Ref No.': 'ERN',
  'JioPay Id': 'id',
  'Bank ref No.': 'bankRefNo',
  'Customer Id': 'customerId',
  'Mobile Number': 'mobileNumber',
  Email: 'email',
  'Udf 1': 'udf1',
  'Udf 2': 'udf2',
  'Udf 3': 'udf3',
  'Udf 4': 'udf4',
  'Udf 5': 'udf5',
  'Terminal Id': 'terminalId',
  'Offer Code': 'offerCode',
  'Settlement RefNumber': 'settlementRefNumber',
  'Account Number': 'accountNumber',
}

export const mobileAndTabletCheck = () => {
  let check = false
  if (!isOsMobile()) {
    ;(function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a,
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a?.substr(0, 4),
        )
      ) {
        check = true
      }
    })(navigator?.userAgent || navigator?.vendor || window?.opera)
  }
  return check
}

export const useWindowDimensions = () => {
  const [width, setWidth] = useState(Dimensions.get('window').width)
  const isDesktop = Dimensions.get('window').width >= 1024
  const isMobileDevice = mobileAndTabletCheck()
  useEffect(() => {
    let subscription: any
    if (!isMobileDevice) {
      subscription = Dimensions.addEventListener('change', ({ window }) => {
        setWidth(window.width)
      })
    }
    return () => {
      subscription?.remove()
    }
  }, [isDesktop, isMobileDevice, width])
  return width
}

const isValidHex = (hex: string) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)

const getChunksFromString = (st: any, chunkSize: any) => st.match(new RegExp(`.{${chunkSize}}`, 'g'))

const convertHexUnitTo256 = (hexStr: string) => parseInt(hexStr.repeat(2 / hexStr.length), 16)

const getAlphafloat = (a: any, alpha: any) => {
  if (typeof a !== 'undefined') {
    return a / 255
  }
  if (typeof alpha !== 'number' || alpha < 0 || alpha > 1) {
    return 1
  }
  return alpha
}

export const hexToRGBA = (hex: string, alpha?: number) => {
  if (!isValidHex(hex)) {
    throw new Error('Invalid HEX')
  }
  const chunkSize = Math.floor((hex.length - 1) / 3)
  const hexArr = getChunksFromString(hex.slice(1), chunkSize)
  const [r, g, b, a] = hexArr.map(convertHexUnitTo256)
  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`
  } else {
    return `rgb(${r}, ${g}, ${b})`
  }
}

export const groupBy = (arr: Array<any>, key: string) => {
  const initialValue = {}
  if (arr) {
    return arr?.reduce((acc, cval) => {
      const myAttribute = cval[key]
      acc[myAttribute] = [...(acc[myAttribute] || []), { ...cval, isChecked: cval?.isChecked ?? false }]
      return acc
    }, initialValue)
  }
  return []
}

const getDateValue = (dateValue: number): Date => {
  const today = new Date(Date.now())
  return new Date(today.setDate(today.getDate() - dateValue))
}

const getTodayValue = (): Date => {
  const today = new Date(Date.now())
  return new Date(today.setHours(0, 0, 0, 0))
}

const getLastHourValue = (): Date => {
  const today = new Date(Date.now())
  return new Date(today.getTime() - 1000 * 60 * 60)
}

export const getPrevDate = (date: Date, dateVal: number): number => {
  return new Date(date.setDate(date.getDate() - dateVal))?.getTime()
}
export const getSelectedDate = (type: number): Date => {
  const getSelectedValue: any = {
    0: getLastHourValue(),
    1: getTodayValue(),
    2: getDateValue(7),
    3: getDateValue(30),
    4: getDateValue(15),
  }
  return getSelectedValue[type]
}

export const downloadQrPdfFile = (resp: any) => {
  let type = resp.headers['content-type']
  if (mimeTypes.get(type) === undefined) {
    return
  }

  const blob = new Blob([resp?.data], {
    type,
  })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = url
  a.download = `all-in-one-Qr-${`${mimeTypes.get(type)}`}`
  a.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
}

export const capitaliseFirstCharAndRestToLowerCase = (text: string) => {
  return text.replace(/(^\w|\s\w)(\S*)/g, (_, m1: string, m2: string) => m1.toUpperCase() + m2.toLowerCase())
}

export const convertToCaps = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const getHeaderTitle = (title: string) => {
  const titleMap: any = {
    date: 'Txn Date',
    ERN: 'Merchant Ref No',
    RRN: 'JioPay Id',
    totalAmount: 'Txn Amt',
    transactionStatus: 'Txn Status',
    paymentMode: 'Payment method',
    paymentType: 'Payment Type',
    bankRefNo: 'Bank Ref No',
    transactionType: 'Txn Type',
    settlementRefNo: 'Settlement Ref No.',
    accountNumber: 'Account Number',
    refundAmount: 'Refund Amt',
    authCode: 'Auth Code',
    acquirerTerminal: 'Terminal Id',
    surCharge: 'Surcharge Amt',
    convenienceFeeAmount: 'Convenience Fee Amt', // Commented as per request from Santosh and Sujit to remove from FE
    emiCode: 'EMI Code', // Commented as per request from Santosh and Sujit to remove from FE
    merchantName: 'Merchant Name',
    merchantType: 'Merchant Type',
    settlementStatus: 'Settlement Status',
    settledAmount: 'Settled Amount',
    chargeBackReason: 'Chargeback Code', // Commented as per request from Santosh and Sujit to remove from FE
    refundStatus: 'Refund Status',
    settlementDate: 'Settlement Date',
    customerId: 'Customer Id',
    customerName: 'Customer Name',
    mobileNumber: 'Mobile No.',
    email: 'Email',
    offerTransactionAmount: 'Offer Txn Amount',
    cashBackAmount: 'Cashback Amount',
    instantDiscountAmount: 'Instant Discount Amt',
    offerCode: 'Offer Code',
    offerReferenceId: 'Offer Ref ID',
    failureMessage: 'Failure Reason',
  }
  return titleMap[title] ?? title
}

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    transactionDateTime: 100,
    invoice: 80,
    transactionId: 100,
    transactionAmount: 160,
    transactionDisposition: 100,
    cardType: 80,
    issRefData: 100,
    check: 200,
    transactionStatus: 100,
    ERN: 100,
    RRN: 100,
    totalAmount: 72,
    paymentType: 100,
    bankRefNo: 200,
    srno: 40,
    requestId: 200,
    fromDate: 100,
    toDate: 100,
    settledTransactionCount: 24,
    url: 180,
    date: 80,
    paymentMode: 80,
    settledAmount: 72,
    refundCount: 24,
    refundAmount: 100,
    grossAmount: 100,
    settlementAmount: 72,
    referenceNumber: 50,
    refundStatus: 150,
    startDate: 120,
    endDate: 120,
    campaignTitle: 200,
    cId: 200,
    campaignType: 100,
    rewards: 80,
    id: 40,
    tableIndex: 40,
    downloadDelete: 150,
    requestFrom: 80,
    requestTo: 80,
    requestTime: 100,
    fileName: 220,
    refundRequestDate: 200,
    refundProcessedDate: 200,
    failureReason: 600,
    count: 48,
    accepted: 48,
    declined: 48,
    rrn: 220,
    jioLinkId: 40,
    createdAt: 40,
    pushSmsTo: 40,
    reportFormat: 60,
    updatedDate: 70,
    reportConfigTitle: 90,
    reportFrequency: 40,
    actionEditDownload: 180,
    cashbackAmount: 160,
    originalTxnAmt: 160,
    amount: 100,
    instantDiscountAmount: 160,
    offerTransactionAmount: 160,
    action: 60,
    status: 40,
    refundChannel: 60,
    uploadDate: 100,
    totalCount: 50,
    addedCount: 50,
    declinedCount: 50,
    beneficiaryStatus: 120,
    mobileNumber: 120,
    emailId: 120,
    beneficiaryId: 120,
    accountNumber: 120,
    subType: 250,
    beneficiaryName: 200,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

export const getInitRefundCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    check: 70,
    transactionStatus: 100,
    ERN: 200,
    RRN: 220,
    totalAmount: 70,
    paymentType: 100,
    bankRefNo: 200,
    srno: 40,
    requestId: 200,
    fromDate: 200,
    toDate: 200,
    settledTransactionCount: 100,
    url: 360,
    date: 200,
    paymentMode: 170,
    settledAmount: 120,
    refundCount: 70,
    refundAmount: 80,
    settlementAmount: 120,
    referenceNumber: 150,
    refundStatus: 150,
    startDate: 120,
    endDate: 120,
    campaignTitle: 200,
    cId: 200,
    campaignType: 200,
    id: 50,
    downloadDelete: 150,
    requestFrom: 80,
    requestTo: 80,
    requestTime: 100,
    fileName: 220,
    status: 100,
    refundRequestDate: 200,
    refundProcessedDate: 200,
    failureReason: 600,
    count: 120,
    accepted: 120,
    declined: 120,
    rrn: 220,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

export const getStatusFromMap = (inStatus: string) => {
  const statusMap: any = {
    'REFUND SUCCESS': 'SUCCESS',
    'REFUND ACCEPTED': 'ACCEPTED',
    'REFUND FAILED': 'FAILED',
    'REFUND PENDING': 'PENDING',
    'REFUND INITIATED': 'INITIATED',
  }
  return statusMap[inStatus] ?? inStatus
}

export const getWidth = (viewPort: number, item: any) => {
  const columnCount = item && Object.keys(item).length
  const diffColumnCount = columnCount > 8 ? columnCount - 8 : 8 - columnCount
  const calcTableWidth = (diffColumnCount + 8) * 180
  const ret = viewPort > calcTableWidth ? viewPort : calcTableWidth
  return ret
}
// export const arrayBuffer2string = (buf: any) => {
//   return String.fromCharCode.apply(null, new Uint16Array(buf))
// }

export const getRefundStatusMapping = (status: string) => {
  if (typeof status !== 'string') {
    return null
  }
  const splitvalues = status.split(' ')
  if (splitvalues.length > 1) {
    return splitvalues[1]
  }
  return status
}

export const getDifferenceFromEndStartDateTime = (endDateTime: string, startDateTime: string, isIsoFormat = false) => {
  if (!endDateTime || !startDateTime) {
    return 0
  }
  const endTime = Date.parse(isIsoFormat ? endDateTime : endDateTime.replace(' ', 'T'))
  const startTime = Date.parse(isIsoFormat ? startDateTime : startDateTime.replace(' ', 'T'))
  const differenceMilliSecs = endTime - startTime
  return differenceMilliSecs
}

export const getStartDateFromDifference = (
  endDateTime: string,
  differenceMilliSeconds: number,
  isIsoFormat = false,
) => {
  const updatedStartDateTime =
    Date.parse(isIsoFormat ? endDateTime : endDateTime.replace(' ', 'T')) - differenceMilliSeconds
  // console.log('===> updatedStartDateTime', updatedStartDateTime)
  return updatedStartDateTime
}

export const getDateTimeInApiFormat = (mDate: Date) => {
  const dateInYYYYMMDD = `${mDate.getFullYear()}-${roundOfToTwoDigits(mDate.getMonth() + 1)}-${roundOfToTwoDigits(
    mDate.getDate(),
  )}`
  const timeInHHMMSS = `${roundOfToTwoDigits(mDate.getHours())}:${roundOfToTwoDigits(
    mDate.getMinutes(),
  )}:${roundOfToTwoDigits(mDate.getSeconds())}`
  return `${dateInYYYYMMDD} ${timeInHHMMSS}`
}

export const updateEndDateTimeInRequest = (req: any, selectedDateInfo: any = null) => {
  if (req && req.inputFilter) {
    const difference = getDifferenceFromEndStartDateTime(req.inputFilter.endDateTime, req.inputFilter.startDateTime)
    let updatedRequest = req
    const currentDate = new Date()
    // req.inputFilter.endDateTime = '2023-02-11 23:59:57'
    const endDateTime = req.inputFilter.endDateTime
    let endTime = ''
    if (
      selectedDateInfo &&
      selectedDateInfo?.dateLabel === actionMenuStrings.yesterday &&
      endDateTime &&
      endDateTime.length > 0
    ) {
      /* // TODO: if yesterday selected then endDate not required to update currentDate.
      Update only the yesterday Start and End date-time */
      try {
        const endDate = endDateTime.split(' ')[0]
        const endDateArr = endDate.split('-')
        const getLastDay = getYesterday('END')
        if (endDateArr.length && new Date(endDateTime)?.getDate() !== getLastDay?.getDate()) {
          updatedRequest.inputFilter.endDateTime = toDateTime(getLastDay)
          updatedRequest.inputFilter.startDateTime = fromDateTime(getYesterday('START'))
        }
      } catch (error) {
        console.log('failed to get end date and time')
      }
    } else if (
      selectedDateInfo &&
      selectedDateInfo?.dateLabel === actionMenuStrings.today &&
      endDateTime &&
      endDateTime.length > 0
    ) {
      const startDate = getTodayValue()
      const endDate = new Date(Date.now())
      const updatedStartDateTime = getDateTimeInApiFormat(startDate)
      const updatedEndDateTime = getDateTimeInApiFormat(endDate)
      updatedRequest.inputFilter.startDateTime = updatedStartDateTime
      updatedRequest.inputFilter.endDateTime = updatedEndDateTime
    } else if (endDateTime && endDateTime.length > 0) {
      const currTime = `${roundOfToTwoDigits(currentDate.getHours())}:${roundOfToTwoDigits(
        currentDate.getMinutes(),
      )}:${roundOfToTwoDigits(currentDate.getSeconds())}`
      if (endDateTime.includes(' ')) {
        const endDate = endDateTime.split(' ')[0]
        endTime = endDateTime.split(' ')[1]
        let updatedDate = endDate
        if (endDate.includes('-')) {
          const endDateArr = endDate.split('-')
          if (endDateArr[0] && endDateArr[1] && endDateArr[2]) {
            if (
              !(
                currentDate.getFullYear() === +endDateArr[0] &&
                currentDate.getMonth() + 1 === +endDateArr[1] &&
                currentDate.getDate() === +endDateArr[2]
              )
            ) {
              updatedDate = `${currentDate.getFullYear()}-${roundOfToTwoDigits(
                currentDate.getMonth() + 1,
              )}-${roundOfToTwoDigits(currentDate.getDate())}`
            }
          }
        }
        // Update endTime if it does not equal 23:59:59
        updatedRequest.inputFilter.endDateTime = `${updatedDate} ${endTime === '23:59:59' ? endTime : currTime}`
        //Check and update startDateTime
        const startDateTime = req.inputFilter.startDateTime
        if (startDateTime && startDateTime.length > 0) {
          //  update startTime only if it not includes 00:00:00 && 23:59:59
          if (!startDateTime.includes('00:00:00') && !startDateTime.includes('23:59:59')) {
            const sDate = getStartDateFromDifference(updatedRequest.inputFilter.endDateTime, difference)
            let updatedStartDateTime: any = new Date(sDate)
            if (isMobile(true)) {
              // console.log('apptest roundoff start-time', updatedStartDateTime.toString())
              updatedStartDateTime = dateTimeMobileOnly(updatedStartDateTime.toString())
              // console.log('apptest roundoff start-time after', updatedStartDateTime)
            }
            updatedStartDateTime = getDateTimeInApiFormat(updatedStartDateTime)
            updatedRequest.inputFilter.startDateTime = updatedStartDateTime
          }
        }
      }
    }
    return updatedRequest
  } else {
    return req
  }
}

export const updateEndDateTimeInForBeneficiaryFileList = (req: any, dateLabel: string) => {
  if (req) {
    const difference = getDifferenceFromEndStartDateTime(req.toDate, req.fromDate)
    let updatedRequest = req
    const currentDate = new Date()
    // req.inputFilter.endDateTime = '2023-02-11 23:59:57'
    const endDateTime = req.toDate
    let endTime = ''
    if (dateLabel && dateLabel === actionMenuStrings.yesterday && endDateTime && endDateTime.length > 0) {
      /* // TODO: if yesterday selected then endDate not required to update currentDate.
      Update only the yesterday Start and End date-time */
      try {
        const endDate = endDateTime.split(' ')[0]
        const endDateArr = endDate.split('-')
        const getLastDay = getYesterday('END')
        if (endDateArr.length && new Date(endDateTime)?.getDate() !== getLastDay?.getDate()) {
          updatedRequest.toDate = toDateTime(getLastDay)
          updatedRequest.fromDate = fromDateTime(getYesterday('START'))
        }
      } catch (error) {
        console.log('failed to get end date and time')
      }
    } else if (endDateTime && endDateTime.length > 0) {
      const currTime = `${roundOfToTwoDigits(currentDate.getHours())}:${roundOfToTwoDigits(
        currentDate.getMinutes(),
      )}:${roundOfToTwoDigits(currentDate.getSeconds())}`
      if (endDateTime.includes(' ')) {
        const endDate = endDateTime.split(' ')[0]
        endTime = endDateTime.split(' ')[1]
        let updatedDate = endDate
        if (endDate.includes('-')) {
          const endDateArr = endDate.split('-')
          if (endDateArr[0] && endDateArr[1] && endDateArr[2]) {
            if (
              !(
                currentDate.getFullYear() === +endDateArr[0] &&
                currentDate.getMonth() + 1 === +endDateArr[1] &&
                currentDate.getDate() === +endDateArr[2]
              )
            ) {
              updatedDate = `${currentDate.getFullYear()}-${roundOfToTwoDigits(
                currentDate.getMonth() + 1,
              )}-${roundOfToTwoDigits(currentDate.getDate())}`
            }
          }
        }
        // Update endTime if it does not equal 23:59:59
        updatedRequest.toDate = `${updatedDate} ${endTime === '23:59:59' ? endTime : currTime}`
        //Check and update startDateTime
        const startDateTime = req.fromDate
        if (startDateTime && startDateTime.length > 0) {
          //  update startTime only if it not includes 00:00:00 && 23:59:59
          if (!startDateTime.includes('00:00:00') && !startDateTime.includes('23:59:59')) {
            const sDate = getStartDateFromDifference(updatedRequest.toDate, difference)
            let updatedStartDateTime: any = new Date(sDate)
            if (isMobile(true)) {
              // console.log('apptest roundoff start-time', updatedStartDateTime.toString())
              updatedStartDateTime = dateTimeMobileOnly(updatedStartDateTime.toString())
              // console.log('apptest roundoff start-time after', updatedStartDateTime)
            }
            updatedStartDateTime = getDateTimeInApiFormat(updatedStartDateTime)
            updatedRequest.fromDate = updatedStartDateTime
          }
        }
      }
    }
    return updatedRequest
  } else {
    return req
  }
}

export enum apiTypes {
  DEFAULT = 'DEFAULT',
  INSIGHT_SUMMERY = 'INSIGHT_SUMMERY',
  SUBSCRIPTION_HISTORY = 'SUBSCRIPTION_HISTORY',
  CAMPAIGN = 'CAMPAIGN',
}
export const geRequestDateTimeRoundOff = (
  req: any,
  selectedDateInfo: any = null,
  apiType: apiTypes = apiTypes.DEFAULT,
) => {
  switch (apiType) {
    case apiTypes.INSIGHT_SUMMERY:
      return getInsightSummeryDateTimeRoundOff(req, selectedDateInfo)
    case apiTypes.SUBSCRIPTION_HISTORY:
      return roundOffFromDateAndToDate(req, selectedDateInfo)
    case apiTypes.CAMPAIGN:
      return roundOffCampaignFromDateAndToDate(req, selectedDateInfo)
    default:
      return updateEndDateTimeInRequest(req, selectedDateInfo)
  }
}

export const getFutureDay = (date: Date, range: number): Date => {
  const nDate = new Date(date).getTime() + (range - 1) * 24 * 60 * 60 * 1000
  return new Date(nDate)
}

export const getPastDay = (date: Date, range: number): Date => {
  const nDate = new Date(date).getTime() - (range - 1) * 24 * 60 * 60 * 1000
  return new Date(nDate)
}

export const combineUserName = (userName: any) => {
  let string = ''
  if (userName?.firstName) {
    string = userName?.firstName
  }
  if (userName?.middleName) {
    string = string.concat(' ', userName?.middleName)
  }
  if (userName?.lastName) {
    string = string.concat(' ', userName?.lastName)
  }
  return string
}

export const clearSession = () => {
  if (!isOsMobile()) {
    window.sessionStorage.removeItem('sessionData')
    window.sessionStorage.clear()
    window.localStorage.removeItem('midData')
    window.localStorage.removeItem('merchantData')
    window.localStorage.removeItem('sessionData')
    window.localStorage.removeItem('jfsUserId')
    RootStore.user.removeMerchantDetailsFromLocalStorage()
    RootStore.settings.metaData.updateSelectedMercName('')
  }
}

interface requiredPermission {
  arrayName: Array<any> | null
  permissionName: String
}

export const isRequiredPermissionPresent = ({ arrayName, permissionName }: requiredPermission) => {
  return arrayName?.some(function (item) {
    return item?.permissionCode === permissionName
  })
}

export const ENABLE_CSV = true

export const routeNameMapping = {
  [Routes.HOME]: 'Home',
  [Routes.TRANSACTIONS]: 'Transactions',
  [Routes.REFUNDS]: 'Refunds',
  [Routes.INSIGHTS]: 'Insights',
  [Routes.BULK_REFUND]: 'Bulk Refund',
  [Routes.UPIQRCODE]: 'UPI QR code',
  [Routes.DOWNLOADS]: 'Downloads',
  [Routes.SETTINGS]: 'Settings',
  [Routes.USER_MANAGEMENT.ADD_NEW_USER]: 'Settings',
  [Routes.USER_MANAGEMENT.EDIT_USER_ROLE]: 'Settings',
  [Routes.PAYOUTS_BENEFICIARY]: 'Beneficiary',
}

const OTPreg = /^\d{6}$/
export const MobileNumberreg = /^\d{10}$/

export const otp = Yup.string()
  .required('Required')
  .min(6, 'OTP must be 6 digits')
  .matches(OTPreg, 'Only 6 digit otp allowed')

export const mobileNumber = Yup.string()
  .required('Required')
  .min(10, 'Mobile number must be 10 digits')
  .matches(MobileNumberreg, 'Only 10 digit mobile number allowed')

export const getDisableState = (item: any) => {
  if (
    (item?.status?.toUpperCase() === staticStrings.activeStatus.toUpperCase() ||
      item?.status?.toUpperCase() === staticStrings.hotMerchantStatus.toUpperCase()) &&
    item.userStatus.toUpperCase() === staticStrings.activeStatus.toUpperCase()
  ) {
    return false
  }
  return true
}

/*  dd MMM yyyy to dd MMM'yy */
export const convertDate = (time: string) => {
  let formatedTime: any = time
  try {
    if (formatedTime.split(' ')?.length > 1) {
      const values = formatedTime.split(' ')
      // formatedTime = `${values[0]} ${values[1]}'${values[2].slice(-2)}`
      formatedTime = values[0] + ' ' + values[1] + "'" + values[2].slice(-2)
      //console.log('apptest [convertDate] givent date formated', time, ' => ', formatedTime)
    }
  } catch (error) {
    console.log('apptest [convertDate]', error)
  } finally {
    return formatedTime
  }
}

//TODO: mobile only date
export const convertDateTime = (dateTime: string) => {
  let formatedDateTime: any = dateTime
  try {
    if (formatedDateTime.includes(',')) {
      const values = formatedDateTime.split(',')
      const date = values[0].trim()
      const time = values[1].trim()
      const dateValues = date.split('-')
      formatedDateTime = `${dateValues[0]} ${monthShotForm[Number(dateValues[1]) - 1]}'${dateValues[2].slice(
        -2,
      )} ${time}`
    } else if (formatedDateTime.includes('T')) {
      formatedDateTime = formatedDateTime.replace('Z', '')
      const date = new Date(formatedDateTime)
      if (isMobile(true)) {
        formatedDateTime = dateTimeMobileOnly(formatedDateTime)
      }
      formatedDateTime = '' + date.getDate() + ' ' + date.getMonth() + "'" + date.getFullYear()?.toString()?.slice(-2)
    }
    // console.log('apptest [convertDateTime] given datetime to formated', dateTime, ' => ', formatedDateTime)
  } catch (error) {
    console.log('apptest [convertDateTime]', error)
  } finally {
    return formatedDateTime
  }
}

export const getDateTimeToDDMMMYYYY = (formatedDateTime: string, withTime = true) => {
  if (formatedDateTime?.includes(',')) {
    const values = formatedDateTime.split(',')
    const date = values[0].trim()
    const time = values[1].trim()
    const dateValues = date.split('-')
    let dateString: any = `${dateValues[0]} ${monthShotForm[Number(dateValues[1]) - 1]} ${dateValues[2]}`
    if (withTime) {
      dateString = `${dateString}, ${time}`
    }
    return dateString
  } else {
    return formatedDateTime
  }
}

export const getDateTime = () => {
  const today = new Date(Date.now())
  const endTime =
    ('0' + today.getHours()).slice(-2) + ('0' + today.getMinutes()).slice(-2) + ('0' + today.getSeconds()).slice(-2)
  return `${today.getFullYear()}${roundOfToTwoDigits(today.getMonth() + 1)}${roundOfToTwoDigits(
    today.getDate(),
  )}${endTime}`
}
export const IS_REFUND_CHANNEL_ENABLED = false
export const ENABLE_QR_OPTIMIZATION = true

export const shouldAvoidUserEntityCall = Platform.OS === 'android'

export const getFileMimeType: any = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  csv: 'text/csv',
  txt: 'text/plain',
}

export const getYesterday = (type = 'END'): Date => {
  const day = new Date(new Date(new Date().setDate(new Date().getDate() - 1)))
  if (type === 'START') {
    day.setHours(0, 0, 0, 0)
  } else if ('END') {
    day.setHours(23, 59, 59, 999)
  }
  return day
}

export const ENABLE_REPORT_DOWNLOADS_IN_MOBILE = true
export const FILE_DOWNLOADED = 1
export const FILE_DOWNLOAD_INPROCESS = 2
export const DOWNLOAD_FAILED = 3
export const SESSION_EXPIRED = 4
export const OTHER_FORMAT_FILE_DOWNLOAD_INPROCESS = 5

export const sortList = (data: string, sortBy: string, sortDirection: any) => {
  if (sortBy && sortDirection) {
    let list: any = data
    if (data.length > 0) {
      if (isNaN(data[0][sortBy])) {
        list = list.sort((a, b) => {
          return a[sortBy]?.localeCompare(b[sortBy])
        })
        return sortDirection === 'DESC' ? list.reverse() : list
      } else {
        list = list.sort((a, b) => {
          return +a[sortBy] - +b[sortBy]
        })
        return sortDirection === 'DESC' ? list.reverse() : list
      }
    }
  }
  return data
}

export const getFullName = (user: any) => {
  let fullName = ''
  if (user?.firstName) {
    fullName = fullName + user?.firstName
  }
  if (user?.lastName) {
    fullName = fullName + ' ' + user?.lastName
  }
  return fullName
}
export const pages: any = {
  settlement_reporting: {
    no_config_discription:
      "Dear Merchant, you haven't configured any reports yet. Configure your report here. you can configure one or more as per your needs.",
    reports_not_configured: 'Report Configuration not available',
    configure_now: 'Configure Now...',
  },
  create_config: {
    email_recipients: 'E-mail Recipients',
    notification_recipients: 'Notification Recipient',
    subject_line: 'Subject Line',
    subject_line_placeholder:
      'JioPay Alerts - The Settlement Report <selected format> has been created, for MID: <MID>',
    filename: 'Filename',
    filename_placeholder: 'SETT_<MID>_<REPORT DATE & TIME>',
    passkey: 'Passkey',
    passkey_placeholder: 'PASSCODE',
    sftp_configuration: 'SFTP Configuration',
  },
}
export const tooltipConfig = {
  emailConfigInfo: 'This denotes the configuration related to Email as file transfer mode',
  reportTypeInfo:
    'This selection denotes which format of the report is required. The user can also download the sample report format based on the selection',
  reportExtInfo: 'This denotes the type of report file required over Mail/SFTP',
  reportFrequencyInfo: 'This selection denotes the frequency at which the report is required',
  reportValidityInfo:
    'Configuration validity denotes the validity of this configuration, upto which, reports will be sent on an automated basis',
  fileTransferModeInfo: 'File transfer mode denotes the mode with which the user seeks the report',
  configurationTitleInfo: 'This is an open text field and denotes the name of the configuration to be made',
  emailConfigRecipentsInfo: 'This denotes the list of recipients of the mail in which the file is attached',
  emailConfigSubjInfo:
    'This denotes the subject line of the mail which is communicated to the Mail recipients in which the file is attached',
  emailConfigFileNameInfo: 'This denotes the Filename of the attachment in the mail',
  emailConfigPassKeyInfo: 'Passkey denotes the password to open the Zip file attached in the mail',
  sftpConfigInfo: 'This denotes the configuration related to SFTP as file transfer mode',
  sftpConfigRecipentsInfo:
    'This denotes the list of recipients of the mail in which the the notification about the file being attached to the SFTP is conveyed',
  sftpConfigSubjInfo:
    'This denotes the subject of the mail in which the the notification about the file being attached to the SFTP is conveyed',
  sftpConfigFileNameInfo: 'This denotes the Filename of the attachment in the SFTP',
  sftpConfigPassKeyInfo: 'Passkey denotes the password to open the Zip file in the SFTP',
}

export const updateSubjectAndFile = (payload: any, m_id: any, subject: any, file: any) => {
  const currentDate = hyphenSplashSeparatedDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
  try {
    let subjectTitle = pages.create_config.subject_line_placeholder
    let filename = pages.create_config.filename_placeholder
    subjectTitle = subjectTitle.replace('<selected format>', payload.reportFormat)
    subjectTitle = subjectTitle.replace('<MID>', m_id)
    filename = filename.replace('<MID>', m_id)
    filename = filename.replace('<REPORT DATE & TIME>', currentDate)
    payload[subject] = payload[subject] ? payload[subject] : subjectTitle
    payload[file] = payload[file] ? payload[file] : filename
  } catch (e) {
    console.log('error', e)
  }
}

//'Wallets',
// 581: 'Banks',
// 582: 'Card Types',
export const campaignDetailKeys: any = {
  title: 'Campaign Title',
  issueCount: 'Offer Issue Count',
  budget: 'Campaign Budget',
  startDate: 'Campaign starts by:',
  endDate: 'Campaign ends by:',
  description: 'Campaign Description',
  tnc: 'Campaign T&C:',
  eventType: 'Transaction/event type',
  txnCriteria: 'Transaction Criteria',
  bin: 'Bins',
  paymode: 'Payment Mode',
  emiTenure: 'EMI Tenure',
  emiBankName: 'EMI Bank Name',
  roi: 'Rate Of Interest',
  emiDetails: 'EMI',
  Wallets: 'Issuing Wallet',
  Banks: 'Issuing Bank',
  ['Card Types']: 'Issuing Card',
  applicableProducts: 'Applicable on',
  notApplicableProducts: 'Not Applicable on',
  applicableCategories: 'Applicable on',
  notApplicableCategories: 'Not Applicable on',
  offerType: 'Offer Type',
  discountValue: 'Discount Value',
  maxCashback: 'Maximum Cashback/Discount',
  iscampaignLinked: 'Is Campaign Linked?',
  linkedCampaigns: 'Linked Campaign',
}

export const getDateTimeStampInMillis = (date: any) => {
  const arr = date?.split('-') ?? []
  return date ? new Date(+arr[2], arr[1] - 1, +arr[0])?.getTime() : -1
}
export const getWeekRanges = (data: any) => {
  if (data?.length > 0) {
    const lastIndex = data?.length - 1
    const firstDate = data?.[0]?.date
    const lastdate = data?.[lastIndex]?.date
    const firstTimeInMillisec = getDateTimeStampInMillis(firstDate)
    const lastTimeInMillisec = getDateTimeStampInMillis(lastdate)
    const weekTime = 86400000 * 7
    const headersLength = Math.floor((firstTimeInMillisec - lastTimeInMillisec) / weekTime) + 1
    const headers = []
    const getPrevDate = (dateValue: number, days: number): number => {
      const date = new Date(dateValue)
      return new Date(date.setDate(date.getDate() - days))?.getTime()
    }
    new Array(headersLength).fill(0)?.map((_, index) => {
      if (index === 0) {
        headers.push({ l: getPrevDate(firstTimeInMillisec, 6), h: new Date(firstTimeInMillisec) })
      } else {
        headers.push({
          l: getPrevDate(firstTimeInMillisec, (index + 1) * 7 - 1),
          h: getPrevDate(firstTimeInMillisec, index * 7),
        })
      }
    })
    return headers
  }
}

export const formatDateRange = (datel, dateH) => {
  const minDate = new Date(datel)
  const maxDate = new Date(dateH)
  if (minDate?.getFullYear() === maxDate?.getFullYear()) {
    if (minDate?.getMonth() === maxDate?.getMonth()) {
      return `${roundOfToTwoDigits(minDate?.getDate())} -${roundOfToTwoDigits(maxDate?.getDate())} ${
        monthShotForm[maxDate?.getMonth()]
      } ${maxDate?.getFullYear()}`
    } else {
      return `${roundOfToTwoDigits(minDate?.getDate())} ${monthShotForm[minDate?.getMonth()]} -${roundOfToTwoDigits(
        maxDate?.getDate(),
      )} ${monthShotForm[maxDate?.getMonth()]} ${maxDate?.getFullYear()}`
    }
  } else {
    return `${roundOfToTwoDigits(minDate?.getDate())} ${
      monthShotForm[minDate?.getMonth()]
    } ${minDate?.getFullYear()} -${roundOfToTwoDigits(maxDate?.getDate())} ${
      monthShotForm[maxDate?.getMonth()]
    } ${maxDate?.getFullYear()}`
  }
}
// dd/mm/yy => month fullyear
// ex 12/12/22 => December 2022
// ex 2023-12-05 => December 2022
export const convertDateToMonthAndYear = (date: string) => {
  if (date?.includes('/')) {
    const mm = date.slice(3, 5)
    const yy = date.slice(6, 8)
    const fullYear = convertYear(yy)
    const month = monthsMapper.get(mm) ?? 'NA'
    // console.log('fullYear', fullYear, month)
    return `${month} ${fullYear}`
  } else if (date?.includes('-')) {
    const dateArr = date.split('-')
    const fullYear = dateArr[0]?.length > 2 ? dateArr[0] : convertYear(dateArr[0])
    const month = monthsMapper.get(dateArr[1]) ?? 'NA'
    return `${month} ${fullYear}`
  } else {
    return date
  }
}

export const getStartEndDateTimeFromDate = (inputDate: string) => {
  let formattedDate
  if (inputDate) {
    formattedDate = inputDate.split(',')[0]
    const formattedDateArray = formattedDate.split('-')
    formattedDate = `${formattedDateArray[2]}-${formattedDateArray[1]}-${formattedDateArray[0]}`
  }
  const startDateTime = inputDate ? `${formattedDate} 00:00:00` : undefined
  const endDateTime = inputDate ? `${formattedDate} 23:59:59` : undefined
  return { startDateTime, endDateTime }
}

export const getEndDate = (transactionDate: any) => {
  const endDate = transactionDate?.split(',')?.[0]?.split('-')
  const endDateTime = new Date(+endDate[2], +endDate[1] - 1, +endDate[0])
  const endDateInMills = new Date(endDateTime.setDate(endDateTime.getDate() + 31))?.getTime()
  const currentDateInMillis = new Date(Date.now())?.getTime()
  if (endDateInMills > currentDateInMillis) {
    return toDateTime(new Date(currentDateInMillis))
  }
  return toDateTime(new Date(endDateInMills))
}
export const removeDuplicateElement = (data: any) => {
  return data.filter((item: string, index: number) => data.indexOf(item) === index && item !== null)
}

export const formatAmount = (amount: string) => {
  return Number(parseFloat(amount).toFixed(2)).toLocaleString('en', {
    minimumFractionDigits: 2,
  })
}

export const logEvent = async (event: string, desc: string) => {
  console.log('Log', event, desc)
}

export const convertWordCapitalize = (text: any) => {
  try {
    let final = ''
    text?.split('')?.reduce((init, current, index) => {
      const prev = text[index - 1]
      if (index === 1) {
        final = `${init.toUpperCase()}${current.toLowerCase()}`
      } else if (prev === ' ') {
        final += current.toUpperCase()
      } else if (current) {
        final += current.toLowerCase()
      } else {
        final += final
      }
    })
    return final
  } catch (error) {
    return text
  }
}

export const NotificationServiceModule = undefined

export const SMSUserConsentModule = undefined

export const ScreenLockModule = undefined

export const ContactsModule = undefined

const { REACT_APP_USE_STREAM_SAVER = 'false' } = (window?._env_ ?? {})

export const downloadFile = async (resp, originalfileName) => {
  let fileInfo = resp.headers.get('content-disposition')
  let contentType = resp.headers.get('content-type')
  const fileNameForDownload = fileInfo?.slice(fileInfo.indexOf('=') + 1, fileInfo.lastIndexOf('.')) ?? originalfileName
  const finalExt = !fileNameForDownload.includes(`${mimeTypes.get(contentType)}`) ? `${mimeTypes.get(contentType)}` : ''
  const fileName = fileNameForDownload + finalExt
  if (REACT_APP_USE_STREAM_SAVER === 'true') {
    const readableStream = resp.body
    streamSaver.default.mitm = `${window?._env_?.REACT_APP_URL}/mitm.htm`
    const fileStream = streamSaver.createWriteStream(fileNameForDownload + finalExt)
    if (window.WritableStream && readableStream.pipeTo) {
      readableStream.pipeTo(fileStream).then(() => console.log('done writing'))
    }
    window.writer = fileStream.getWriter()
    const reader = resp.body.getReader()
    const pump = () =>
      reader.read().then((res: any) => (res.done ? window.writer.close() : window.writer.write(res.value).then(pump)))
    pump()
  } else {
    const blob = await resp.blob()
    const objectUrl = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = objectUrl
    link.download = fileName || 'downloaded-file'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 150)
  }
}
